import { db } from '.';

const groupsRef = db.collection('groups');

async function addGroupToDB({ id, ...docData }) {
  const newGroupRef = groupsRef.doc();
  await newGroupRef.set(docData);
  return newGroupRef;
}

async function getGroupFromDB(id) {
  const groupSnap = await groupsRef.doc(id).get();
  return {
    id,
    ...groupSnap.data()
  };
}

async function updateGroupInDB({ id, ...docData }) {
  await groupsRef.doc(id).update(docData);
}

export default {
  add: addGroupToDB,
  get: getGroupFromDB,
  update: updateGroupInDB
};
